import {TimelineEventProducer} from './TimelineEventProducer'
import {BehaviorSubject} from 'dispatcher'

export interface TimelineActionProps {
  producer: TimelineEventProducer
}

export interface TimelineAction<E extends TimelineActionProps> {
  id: string
  // REACT NODE - IT WILL RECEIVE THE PROPS IN THIS OBJECT
  // eslint-disable-next-line @typescript-eslint/ban-types
  node: Function
  props: E
}

export interface TimelineMessageCreatorSettings {
  disabled: boolean
}

type ActionArrayType = unknown & TimelineActionProps

export class TimelineActionManager {
  protected actions: TimelineAction<ActionArrayType>[] = []
  protected subject: BehaviorSubject<TimelineAction<ActionArrayType>[]> =
    new BehaviorSubject<TimelineAction<ActionArrayType>[]>([])
  protected chatSettings: BehaviorSubject<TimelineMessageCreatorSettings> =
    new BehaviorSubject<TimelineMessageCreatorSettings>({
      disabled: false
    })

  protected notify() {
    this.subject.next(this.actions)
  }

  // Replace all presented action with current one
  replace(actions: TimelineAction<ActionArrayType>[]) {
    this.actions = actions
    this.notify()
  }

  // Push another action into the list
  addAction(action: TimelineAction<ActionArrayType>) {
    this.actions.push(action)
    this.notify()
  }

  // Remove action from list by ID
  removeAction(id: string) {
    this.actions = this.actions.filter((a) => a.id !== id)
    this.notify()
  }

  subscribe(observer: (values: TimelineAction<ActionArrayType>[]) => void) {
    this.subject.subscribe(observer)
    this.notify()
  }

  complete() {
    this.subject.complete()
    this.chatSettings.complete()
  }

  settings(observer: (values: TimelineMessageCreatorSettings) => void) {
    this.chatSettings.subscribe(observer)
  }

  enableChat() {
    this.chatSettings.next({
      disabled: false
    })
  }

  disableChat() {
    this.chatSettings.next({
      disabled: true
    })
  }

  isChatDisabled() {
    return this.chatSettings.value.disabled
  }

  getCurrentActions() {
    return [...this.actions]
  }
}
